export default {
  namespaced: true,

  state: () => ({
    departmentId: null,
    refreshCardsHandler: 0 // whenever we change this, departmentInfo and totalInfo cards will re-fetch
  }),

  getters: {
    selectedDepartmentId(state, getters, rootState, rootGetters) {
      if (state.departmentId) return state.departmentId
      return rootGetters['predictions/systemDepartment']?.id
    }
  },

  mutations: {
    setDepartmentId: (state, payload) => (state.departmentId = payload),
    refreshCards: state => state.refreshCardsHandler++
  }
}
